
/**
 * Pseudo 3D effect jQuery plugin. Very simple to use: several layers
 * glued together into a 3D effect. For example it can be used on site-header.
 *
 * @name jQuery Smart3D plugin
 * @license GPL
 * @version 0.3.4
 * @date January 30, 2011
 * @category jQuery plugin
 * @author Yevhen Kotelnytskyi (evgennniy@gmail.com)
 * @copyright (c) 2011 - 2013 Yevhen Kotelnytskyi (http://4coder.info/en/)
 * @example Visit http://4coder.info/en/code/jquery-plugins/smart3d/ for more informations about this jQuery plugin
 **/
import $ from './jquery.min.js'
(function () {
  $.fn.smart3d = function (settings) {

    var thisObj = this; // 获取移动的盒子，jquery对象
    if (thisObj.length == 0) return false; // 如果没有对象则返回
    var thisEl = thisObj[0]; // 获取移动的盒子，DOM对象

    // Settings默认配置
    settings = $.extend({
      frameWidth: $(this).width() * 1.05, // 移动的元素的宽度--要比thisObj的大
      frameHeight: $(this).height() * 1.1, // 移动的元素的宽度--要比thisObj的大
      horizontal: true, // 水平移动
      vertical: true, // 垂直移动
      firstStatic: false, // 第一张不移动
      lastStatic: false, // 最后一张不移动
      invertHorizontal: false, // 水平反向移动
      invertVertical: false // 垂直反向移动
    }, settings);

    var width = $(this).width(); // 获取盒子的宽度
    var height = $(this).height(); // 获取盒子的高度
    var offset_x = settings['frameWidth'] - width; // 计算可移动的水平距离
    var offset_y = settings['frameHeight'] - height; // 计算可移动的垂直距离

    var lis = thisObj.find('.animate-item'); // 获取需要移动的元素

    var oldArr = []
    lis.each(function (index) {
      oldArr[index] = {}
      oldArr[index]['oldLeft'] = parseFloat($(this).css('left'))
      oldArr[index]['oldTop'] = parseFloat($(this).css('top'))
    })

    thisObj.pos_x = 0;
    thisObj.pos_y = 0;


    // 鼠标在盒子上移动时
    thisObj.mousemove(function (e) {
      // 如果水平移动
      if (settings['horizontal']) {
        // 获取匹配元素相对滚动条左侧的偏移
        var scroll = $('html').scrollLeft();
        if (!scroll) scroll = $('body').scrollLeft();
        // 获取鼠标相对盒子左侧的水平距离
        var x = e.clientX - thisObj.offset().left + scroll;
        if (x > width) {
          x = width;
        }
        thisObj.x = x

        // 计算需要移动的x轴的位移
        if (settings['invertHorizontal']) {
          thisObj.pos_x = offset_x / 2 - (x / width * offset_x);
        } else {
          thisObj.pos_x = (x / width * offset_x) - offset_x / 2;
        }
      }
      if (settings['vertical']) {
        var scroll = $('html').scrollTop();
        if (!scroll) {
          scroll = $('body').scrollTop();
        }
        var y = e.clientY - thisObj.offset().top + scroll;
        if (y > height) {
          y = height;
        }

        if (settings['invertVertical']) {
          thisObj.pos_y = offset_y / 2 - (y / height * offset_y);
        } else {
          thisObj.pos_y = (y / height * offset_y) - offset_y / 2;
        }
      }
    });

    function smart3d_animate() {
      for (var i = 1; i <= lis.length; i++) {
        if ((settings['lastStatic']) && (i == lis.length)) {
          continue;
        }
        if ((settings['firstStatic']) && (i == 1)) {
          continue;
        }
        if (settings['horizontal']) {
          // 获取当前的left值
          var cur_l = parseFloat($(lis[i - 1]).css('left')) ;
          // 计算新的left值
          var new_l = thisObj.pos_x * (i / lis.length) + oldArr[i - 1]['oldLeft']
          $(lis[i - 1]).css('left', (new_l + cur_l * 6) / 7);
        }
        if (settings['vertical']) {
          var cur_l = parseFloat($(lis[i - 1]).css('top'));
          var new_l = thisObj.pos_y * (i / lis.length) + oldArr[i - 1]['oldTop']
          $(lis[i - 1]).css('top', (new_l + cur_l * 6) / 7);
        }
      }
    }

    this.timer = setInterval(smart3d_animate, 40);
    this.destroy = function () {
      clearInterval(this.timer)
    }
    return this;
  };
})();



//////////////////
// WEBPACK FOOTER
// ./static/js/jquery-smart3d.js
// module id = 636
// module chunks = 1